export const KINDS = {
  EMPHASIS: 'Emphasis',
  UNDERLINE: 'Underline',
} as const

export const SIZES = {
  S: 'S',
  XS: 'XS',
  XXS: 'XXS',
} as const

export const COLORS = {
  BLACK: 'Black',
  BONDI_MINT: 'Bondi Mint',
  FIRE: 'Fire',
  GRAY10: 'Gray10',
  GRAY20: 'Gray20',
  GRAY30: 'Gray30',
  GRAY40: 'Gray40',
  GRAY50: 'Gray50',
  GRAY60: 'Gray60',
  GRAY70: 'Gray70',
  GRAY80: 'Gray80',
  GRAY90: 'Gray90',
  GRAY96: 'Gray96',
  LEMON_DARK: 'Lemon Dark',
  LEMON_PASTEL: 'Lemon Pastel',
  MOSS_GEM: 'Moss Gem',
  MOSS_MID: 'Moss Mid',
  MOSS_PASTEL: 'Moss Pastel',
  ORCA: 'Orca',
  ORCA_DARK: 'Orca Dark',
  ORCA_PASTEL: 'Orca Pastel',
  PRESS: 'Press',
  WHITE: 'White',
} as const
